import { useTranslation } from "react-i18next";
import ThreeDotLoader from '@shared/components/ThreeDotLoader';

const PricingBar = ({ pricing, isLoading }) => {
  const { t } = useTranslation();
  const price = pricing || {
    deliveryFees: "-",
    refusalFees: "-",
    cancellationFees: "-",
    deadline: "-",
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 items-center justify-evenly bg-muted py-5 rounded-xl mb-8">
      <div className="flex flex-col items-center">
        <span className="text-md font-semibold">
          {t("common.fees.deliveryFees")}
        </span>
        <span className="text-md font-semibold text-primary">
          {isLoading ? (
            <ThreeDotLoader size="sm" />
          ) : (
            <>
              {price.deliveryFees} {t("common.currency")}
            </>
          )}
        </span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-md font-semibold">
          {t("common.fees.refusalFees")}
        </span>
        <span className="text-md font-semibold text-primary">
          {isLoading ? (
            <ThreeDotLoader size="sm" />
          ) : (
            <>
              {price.refusalFees} {t("common.currency")}
            </>
          )}
        </span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-md font-semibold">
          {t("common.fees.cancellationFees")}
        </span>
        <span className="text-md font-semibold text-primary">
          {isLoading ? (
            <ThreeDotLoader size="sm" />
          ) : (
            <>
              {price.cancellationFees} {t("common.currency")}
            </>
          )}
        </span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-md font-semibold">{t("common.deadline")}</span>
        <span className="text-md font-semibold text-primary">
          {isLoading ? <ThreeDotLoader size="sm" /> : price.deadline}
        </span>
      </div>
    </div>
  );
};

export default PricingBar;
